export default {
  products_home: 'Products',
  get_started_uppercase: 'Get Started',
  documentation_home: 'Documentation',

  products: 'Products',
  multiplayer: 'Multiplayer',
  social: 'Social',
  content_footer: 'Content',
  economy: 'Economy',
  analytics: 'Analytics',
  engagement: 'Engagement',
  resources: 'Resources',
  docs: 'Docs',
  support: 'Support',
  contact_us_footer: 'Contact Us',
  contact_for_product: 'Contact for product updates, events and cooperation',
  we_are_online: 'We\'re Online',
  search_all: 'Search all Services',
  no_search_result: 'No search results.',
  document_center: 'Document Center',
};
